// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 31/3/2023
 */

.Resource_headingContainer__n-WfI {
    display: flex;
    justify-content: space-between;
}

.Resource_closeButton__kqLvH {
    padding: 0.2rem;
    border: 1px #5A9BD8 solid;
    color: #5A9BD8;
}

.Resource_formItem__UhnaD {
    margin-top: 1rem;
}

.Resource_formLabel__afnha {
    font-weight: 600;
margin-top: 10px !important;
}

.Resource_formInput__VP3o5 {
    margin-top: 0.3rem;
    /* height: 10px; */
}

.Resource_validation__IT3eE {
    color: red;
}

.Resource_buttonContainer__cnSwN {
    margin-top: 5rem;
    margin-bottom: 1rem;
    display: flex;
    justify-content: center;
}

.Resource_submitButton__0txgL {
    width: 10rem;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Resource/Resource.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB,2BAA2B;AAC3B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 31/3/2023\r\n */\r\n\r\n.headingContainer {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.closeButton {\r\n    padding: 0.2rem;\r\n    border: 1px #5A9BD8 solid;\r\n    color: #5A9BD8;\r\n}\r\n\r\n.formItem {\r\n    margin-top: 1rem;\r\n}\r\n\r\n.formLabel {\r\n    font-weight: 600;\r\nmargin-top: 10px !important;\r\n}\r\n\r\n.formInput {\r\n    margin-top: 0.3rem;\r\n    /* height: 10px; */\r\n}\r\n\r\n.validation {\r\n    color: red;\r\n}\r\n\r\n.buttonContainer {\r\n    margin-top: 5rem;\r\n    margin-bottom: 1rem;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.submitButton {\r\n    width: 10rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headingContainer": `Resource_headingContainer__n-WfI`,
	"closeButton": `Resource_closeButton__kqLvH`,
	"formItem": `Resource_formItem__UhnaD`,
	"formLabel": `Resource_formLabel__afnha`,
	"formInput": `Resource_formInput__VP3o5`,
	"validation": `Resource_validation__IT3eE`,
	"buttonContainer": `Resource_buttonContainer__cnSwN`,
	"submitButton": `Resource_submitButton__0txgL`
};
export default ___CSS_LOADER_EXPORT___;
